import { z } from 'zod/v4';

export const VIDEO_EDIT_PATH = '/ai/video-edit';

const videoEditDeepLinkSchema = z.object({
    contentId: z.coerce.number().int().positive(),
});

export type VideoEditDeepLink = z.infer<typeof videoEditDeepLinkSchema>;

/**
 * Returns null for anything that isn't a usable deep link, so the page can fall back to its normal
 * empty state rather than failing the render.
 */
export function parseVideoEditDeepLink(value: unknown): VideoEditDeepLink | null {
    const result = videoEditDeepLinkSchema.safeParse(value);

    return result.success ? result.data : null;
}
